import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { RatingsGridMain } from './RatingsGridMain'
import { RatingsGridY } from './RatingsGridY'
import { RatingsGridX } from './RatingsGridX'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  animate?: boolean
}

export const RatingsGrid = ({ animate = true, ...props }: Props) => (
  <FlexBox
    className={css`
      margin-top: 20px;
      gap: 2px;
      width: 100%;
    `}
    alignItems="stretch"
    {...props}
  >
    <FlexBox
      className={css`
        width: 100%;
        padding-right: 15px;
      `}
      flexDirection="column"
    >
      <div
        className={css`
          position: relative;
          height: 180px;
        `}
      >
        <RatingsGridMain animate={animate} />
        <RatingsGridY />
      </div>
      <RatingsGridX />
    </FlexBox>
  </FlexBox>
)
